/**
 * Сущность «Проект» — то, что пользователь открывает, правит и сохраняет.
 *
 * Проект = паспорт (id, название, описание) + слои чертежа. Это единый документ:
 * его целиком кладут в localStorage, выгружают файлом и позже отдадут на бэкенд.
 * Движки 2D / 3D / развёрток читают из него слои и только рисуют — свою модель
 * ни один из них не заводит.
 */
import type { PlanLayers } from "@/shared/plan";

export interface ProjectView3DSettings {
	/** Направление внешнего света по горизонту, градусы $0..359$. */
	sunAzimuth: number;
	/** Высота внешнего света над полом, градусы $10..75$. */
	sunElevation: number;
	/** Рисовать тени от внешнего и внутренних источников. */
	shadows: boolean;
	/** Включать свет от приборов каталога с `lightSource.enable`. */
	sourceLights: boolean;
}

export const DEFAULT_PROJECT_VIEW_3D: ProjectView3DSettings = {
	sunAzimuth: 215,
	sunElevation: 45,
	shadows: true,
	sourceLights: false,
};

export interface Project {
	/** Идентификатор проекта — понадобится, когда проекты переедут на сервер */
	id: string;
	/** Например, «Квартира на Вишнёвой» */
	name: string;
	/** Свободный текст: адрес, заказчик, заметки */
	description: string;
	/** Чертёж — по одному слою каждого вида */
	layers: PlanLayers;
	/** Сохраняемые настройки рендеринга 3D-вида. */
	view3d: ProjectView3DSettings;
}
